/**
 * Resolve figure/table cross-reference tokens ({{fig:id}} / {{tbl:id}}) into
 * the current label ("Figure 2" / "Фигура 2") for reading views.
 * Numbers are never stored in the text, so reordering renumbers everything.
 */
const TOKEN_RE = /\{\{(fig|tbl):([A-Za-z0-9-]{4,40})\}\}/g;

export function resolveAssetRefs(markdown, labels = {}, words = {}) {
  if (!markdown) return markdown || '';
  return markdown.replace(TOKEN_RE, (match, kind) => {
    if (labels[match]) return labels[match];
    const word = kind === 'fig' ? (words.figure_word || 'Figure') : (words.table_word || 'Table');
    return `${word} ?`;
  });
}
